import React, { FC } from 'react'
import classNames from 'classnames'

import { Typography } from '@/atoms'
// import { Spacer } from '@/layout'
import {
  SecurityModalCardTitleProps,
  SecurityModalCardBodyProps,
  SecurityModalCardProps,
} from '@/types'
import { getStyledElementProps } from '@/utils'
// import solutionImage from './validacion-identidad.png'
import styles from './security-modal-card.module.scss'

export const SecurityModalCardTitle: FC<SecurityModalCardTitleProps> = ({
  // icon,
  children,
  // iconColor = 'gray-6',
  // iconSize = 'xl',
  ...props
}) => {
  return (
    <div className={styles['title']}>
      {/*{icon && <Icon name={icon} color={iconColor} size={iconSize} />}*/}
      <Typography
        variant={'featured-3'}
        tag={'span'}
        typographyColor={'gray-7'}
        {...props}
      >
        {children}
      </Typography>
    </div>
  )
}

export const SecurityModalCardBody: FC<SecurityModalCardBodyProps> = ({
  // icon,
  children,
  // iconColor = 'gray-6',
  // iconSize = 'xl',
  ...props
}) => {
  return (
    <div className={styles['body']}>
      <Typography
        variant={'body-1'}
        tag={'span'}
        typographyColor={'gray-6'}
        {...props}
      >
        {children}
      </Typography>
    </div>
  )
}

export const SecurityModalCard: FC<SecurityModalCardProps> = ({
  children,
  variant = 'default',
  image,
  alt = '',
  width = '165',
  height = '165',
  loading = 'lazy',
  // onClose,
  ...props
}) => {
  const styledProps = getStyledElementProps(
    props,
    classNames(styles['root'], styles[variant])
  )
  return (
    <div {...styledProps}>
      {image && (
        <img
          className={styles['image']}
          src={image}
          alt={alt}
          width={width}
          height={height}
          loading={loading}
        />
      )}
      {children}
    </div>
  )
}
